import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=3c86045e&scoped=true&"
import script from "./RichText.vue?vue&type=script&lang=js&"
export * from "./RichText.vue?vue&type=script&lang=js&"
import style0 from "./RichText.vue?vue&type=style&index=0&id=3c86045e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86045e",
  null
  
)

export default component.exports